<agr-wrapper>
  <router-outlet></router-outlet>
</agr-wrapper>
